module.exports = __webpack_public_path__ + "static/img/invite.d70dcdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/invite.png
// module id = 912
// module chunks = 1